import { createFileRoute } from "@tanstack/react-router";

import { LegalAcknowledgementsPage } from "@/pages/Admin/legal/LegalAcknowledgementsPage";

export const Route = createFileRoute("/app/admin/legal/acknowledgements")({
  component: LegalAcknowledgementsPage,
});
